import { render, staticRenderFns } from "./resultatClasse.vue?vue&type=template&id=4a0e4d11&scoped=true&"
import script from "./resultatClasse.vue?vue&type=script&lang=js&"
export * from "./resultatClasse.vue?vue&type=script&lang=js&"
import style0 from "./resultatClasse.vue?vue&type=style&index=0&id=4a0e4d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e4d11",
  null
  
)

export default component.exports